<template lang="html">
  <div
    :class="wrapperClasses"
    class="vue-suggestion">
    <div
      :class="[{ 'vue-suggestion-selected': value }, inputWrapperClasses]"
      class="vue-suggestion-input-group">
      
      <input
       ref="ii"
        v-model="searchText"
        :class="inputClasses"
        :placeholder="placeholder"
        :disabled="disabled"
        type="text"
        style="width:90%;"
        class="vue-suggestion-input2"
        @blur="blur"
        @focus="focus"
        @input="inputChange"
        @keydown.enter.prevent="keyEnter"
        @keydown.up.prevent="keyUp"
        @keydown.down.prevent="keyDown">
       
         <v-icon v-if="hasFocus" class="clearIcon" @click="clear()">$vuetify.icons.clear</v-icon>
      <slot name="searchSlot"/>
    </div>
   <!-- <slot >
      </slot>
      -->
    
    <slot
     
      :class="suggestionListClasses"
      name="suggestionList"
      class="vue-suggestion-list-slot">
        <div class="vue-suggestion-list" v-if="showList">  
        <div
          v-for="(item, i) in items"
          :key="'itemSugg_'+i"
          :class="[{ 'vue-suggestion-item-active': i === cursor }, suggestionItemWrapperClasses]"
          class="vue-suggestion-list-item"
          @click="selectItem(item)"
          @mouseover="cursor = i">
          <div
            :class="suggestionItemClasses"
            :is="itemTemplate"
            :item="item.text"/>
        </div>
      </div>
    </slot>
   
      
  </div>
</template>

<script>
export default {
  name: 'VueSuggestion',
  props: {
    itemTemplate: {
      type: Object,
      required: true,
    },
    onItemSelected: {
      type: Function,
      required: true,
    },
    onItemChanged: {
      type: Function,
      required: true,
    },
    minLen: { type: Number, default: 2 },
    value: {
      type: [Object, String, Number],
      default: null,
    },
    setLabel: { type: Function, default: item => item },
    onKeyEnter: { type: Function, default: item => item },
    allItems: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    inputClasses: { type: String, default: '' },
    wrapperClasses: { type: String, default: '' },
    inputWrapperClasses: { type: String, default: '' },
    suggestionListClasses: { type: String, default: '' },
    suggestionGroupClasses: { type: String, default: '' },
    suggestionGroupHeaderClasses: { type: String, default: '' },
    suggestionItemWrapperClasses: { type: String, default: '' },
    suggestionItemClasses: { type: String, default: '' },
  },
  data() {
    return {
      searchText: '',
      showList: false,
      cursor: 0,
      hasFocus:false,
      items:[]
    };
  },
    
  watch: {
    value: {
      handler(value) {
        if (!value) {
          return;
        }
        //console.log('---->handler:'+value)
        this.searchText = this.setLabel(value);
      },
      deep: true,
    },
    'items.length': function () {
      // Items might be changed from Promise after searching
      // So we need the check if we should show the suggestion list
      this.showList = this.isAbleToShowList();
    },
  },
  created() {
    this.checkMissingProps();
  },
  mounted() {
    if (this.value) {
      this.searchText = this.setLabel(this.value);
    }
  },
  methods: {
    clear(){
    this.searchText=""
    //this.$refs.ii.focus()
    },
    inputChange(e) {
      this.searchText=e.target.value
      this.showList = this.isAbleToShowList();
      this.cursor = 0;
      this.filterResults()
      
      this.$emit('onInputChange', this.searchText);
      this.onItemChanged(this.searchText)
    },
    filterResults() {
      const text=this.searchText.toLowerCase()
        this.items = this.allItems.filter(
          //item => item.toLowerCase().indexOf(text) > -1);
          item => item.text.toLowerCase().indexOf(text) > -1);
        return
      },
    isAbleToShowList() {
      return (this.searchText || '').length >= this.minLen && this.items.length > 0;
    },
    checkMissingProps() {
      if (!this.itemTemplate) {
       // console.warn('You need to pass `template` as the suggestion list item template');
      }
    },
    focus() {
      this.hasFocus=true
      //event.target.select()
      this.$emit('focus', this.searchText);
      this.showList = this.isAbleToShowList();
    },
    blur() {
      this.$emit('blur', this.searchText);
      // set timeout for the click event to work
      setTimeout(() => {
        this.showList = false;
        this.hasFocus=false
      }, 200);
    },
    selectItem(item) {
      if (item) {
        this.searchText = this.setLabel(item.text);
        this.$emit('onItemSelected', item);
      }
      this.$emit('input', item);
      this.onItemSelected(item)
      this.searchText=''
    },
    keyUp() {
      this.$emit('keyUp', this.searchText);
      if (this.cursor > 0) {
        this.cursor -= 1;
      }
    },
    keyDown() {
      this.$emit('keyDown', this.searchText);
      if (this.cursor < this.items.length - 1) {
        this.cursor += 1;
      }
    },
    keyEnter() {
      if (this.showList && this.items[this.cursor]) {
        this.selectItem(this.items[this.cursor]);
        this.showList = false;
      }else{
        if (this.onKeyEnter){
        this.onKeyEnter(this.searchText)
        }
      }
      this.$emit('onEnter', this.items[this.cursor]);
      
    },
  },
};
</script>
